import { Component, Input } from '@angular/core';
import { MicroescapesConfiguration } from '../models/microescapes-config.model';

@Component({
    selector: 'app-microescapes',
    templateUrl: './templates/microescapes.component.html'
})
export class MicroescapesComponent {

    public cardsToShow = 0;
    _config!: MicroescapesConfiguration;

    @Input()
    set config (value: MicroescapesConfiguration) {
        if(!value) { return; }
        this._config = value;
        this.cardsToShow = value.cardsToShow;
    }

    get config(): MicroescapesConfiguration {
        return this._config;
    }

    showMoreCards() {
        this.cardsToShow += this.cardsToShow;
    }
}
